import request from '@/utils/response.js';


// 拍卖会公告列表
export function getNotice(params) {
    return request({
        url: '/api/getNotice',
        method: 'get',
        params
    })
}
// 获取拍卖会列表
export function getAuction(params) {
    return request({
        url: '/api/getAuction',
        method: 'get',
        params
    })
}
// 标的列表
export function getTargets(params) {
    return request({
        url: '/api/getTargets',
        method: 'get',
        params
    })
}

// 底部接口
export function getSiteConfig(params) {
    return request({
        url: '/api/common/getSiteConfig',
        method: 'get',
        params
    })
}
// 轮播图
export function getSlide(params) {
    return request({
        url: '/api/getSlide',
        method: 'get',
        params
    })
}
